













import { Component, Vue } from 'vue-property-decorator'
import Form from '@/components/Auth/Form.vue'
import { ApiService } from '@/api/api.service'
import { Step, StepRight, FinalRight } from '@/types/form'
import { isValidEmail } from '@/utils/email'
import { NewsletterRequest } from '@/types/newsletter'

interface ValidateReturn {
    valid: boolean
    errorMessage: string
}

@Component({
    components: {
        Form,
    },
})
export default class AlertForm extends Vue {
    loading: boolean = true
    firstname: string = 'foo'

    steps: Step[] = [
        {
            name: 'infos',
            valid: false,
            left: null,
            right: {
                type: 'step',
                title: 'Bonjour ! Comment vous appelez-vous ?',
                fields: [
                    {
                        name: 'firstname',
                        type: 'text',
                        value: '',
                        placeholder: 'Votre prénom',
                    },
                    {
                        name: 'lastname',
                        type: 'text',
                        value: '',
                        placeholder: 'Votre nom',
                    },
                ],
                isValid: async fields => {
                    const valid =
                        fields[0].trim() !== '' && fields[1].trim() !== ''

                    // Si valid on remplace le prénom dans les hobbies
                    if (valid) {
                        const firstname = fields[0].trim()

                        const hobbiesStep = this.steps.find(step => {
                            return step.name === 'hobbies'
                        })

                        if (hobbiesStep && hobbiesStep.right.type === 'step') {
                            const right = hobbiesStep.right as StepRight

                            right.title = right.title_template.replace(
                                '#firstname',
                                firstname
                            )
                        }
                    }

                    return {
                        valid,
                        errorMessage:
                            (fields[0].trim() === '' ||
                                fields[1].trim() === '') &&
                            'Votre nom et prénom doivent contenir au moins une lettre',
                    }
                },
            },
        },
        {
            name: 'project',
            valid: false,
            left: null,
            right: {
                type: 'step',
                title:
                    "Enchanté ! Permettez-nous d'en savoir plus sur votre projet immobilier, de quel type de bien rêvez-vous ?",
                fields: [
                    {
                        name: 'project',
                        type: 'textarea',
                        value: '',
                        placeholder: '',
                    },
                ],
                isValid: async fields => {
                    const valid = fields[0].trim() !== ''

                    return {
                        valid,
                        errorMessage:
                            !valid && 'Il y a un problème dans le formulaire',
                    }
                },
            },
        },
        {
            name: 'hobbies',
            valid: false,
            left: null,
            right: {
                type: 'step',
                title_template:
                    'Qu’aimez vous dans la vie #firstname ? Vos centres d’intérêt nous aident à trouver vos futurs voisins.',
                title:
                    'Qu’aimez vous dans la vie ? Vos centres d’intérêt nous aident à trouver vos futurs voisins.',
                fields: [
                    {
                        name: 'hobbies',
                        type: 'select',
                        multiple: true,
                        value: '',
                        placeholder: `Sélectionnez un ou plusieurs centres d'intérêt`,
                        options: [
                            { label: 'Foo', value: 'Foo' },
                            { label: 'Bar', value: 'Bar' },
                            { label: 'Lorem', value: 'Lorem' },
                            { label: 'Ipsum', value: 'Ipsum' },
                        ],
                    },
                ],
                isValid: async fields => {
                    return {
                        valid: fields[0].length > 0,
                        errorMessage:
                            fields[0].length === 0 &&
                            'Il y a un problème dans le formulaire',
                    }
                },
            },
        },
        {
            name: 'email',
            valid: false,
            left: null,
            right: {
                type: 'step',
                title: 'Votre adresse e-mail',
                info: 'Promis pas de spam',
                fields: [
                    {
                        name: 'email',
                        type: 'email',
                        value: '',
                        placeholder: 'Votre adresse e-mail',
                    },
                ],
                isValid: async fields => {
                    const email = fields[0].trim()

                    const valid = email !== '' && isValidEmail(email)

                    if (valid) {
                        return await this.validate()
                    }

                    return {
                        valid,
                        errorMessage:
                            !valid && `Le format de votre email est incorrect`,
                    }
                },
            },
        },
        {
            name: 'final',
            left: null,
            right: {
                type: 'final',
                text: `
                      Super ! Vous faites maintenant partie des pré-inscrits pour le tout premier projet Yvivre. <br />
                      Plus que quelques jours à patienter avant que l’aventure ne commence, surveillez votre boite mail !
                  `,
                button: {
                    text: `Retour à l'accueil`,
                    link: 'https://yvivre.com/',
                },
            },
        },
    ]

    get infos(): { firstname: string; lastname: string } | null {
        const infosStep = this.steps.find(step => {
            return step.name === 'infos'
        })

        if (infosStep && infosStep.right.type === 'step') {
            const right = infosStep.right as StepRight

            const firstnameField = right.fields.find(field => {
                return field.name === 'firstname'
            })

            const lastnameField = right.fields.find(field => {
                return field.name === 'lastname'
            })

            const firstname = firstnameField.value
            const lastname = lastnameField.value

            return {
                firstname,
                lastname,
            }
        }

        return null
    }

    get project(): string | null {
        const projectStep = this.steps.find(step => {
            return step.name === 'project'
        })

        if (projectStep && projectStep.right.type === 'step') {
            const right = projectStep.right as StepRight

            const projectField = right.fields.find(field => {
                return field.name === 'project'
            })

            const project = projectField.value

            return project
        }

        return null
    }

    get hobbies(): number[] | null {
        const hobbiesStep = this.steps.find(step => {
            return step.name === 'hobbies'
        })

        if (hobbiesStep && hobbiesStep.right.type === 'step') {
            const right = hobbiesStep.right as StepRight

            const hobbiesField = right.fields.find(field => {
                return field.name === 'hobbies'
            })

            const hobbies = hobbiesField.value

            const hobbiesIDs = hobbies.map(hobby => {
                return hobby.value.id
            })

            return hobbiesIDs
        }

        return null
    }

    get email(): string | null {
        const emailStep = this.steps.find(step => {
            return step.name === 'email'
        })

        if (emailStep && emailStep.right.type === 'step') {
            const right = emailStep.right as StepRight

            const emailField = right.fields.find(field => {
                return field.name === 'email'
            })

            const email = emailField.value

            return email
        }

        return null
    }

    async validate(): Promise<ValidateReturn> {
        const apiService = new ApiService()

        const req: NewsletterRequest = {
            ...this.infos,
            project: this.project,
            hobbies: this.hobbies,
            email: this.email,
        }

        try {
            const resp = await apiService.postUserNewsletter(req)
            const data = resp.data

            if (data.success) {
                return {
                    valid: true,
                    errorMessage: '',
                }
            }
        } catch (e) {}

        return {
            valid: false,
            errorMessage:
                'Une erreur est survenue lors de votre inscription à la newsletter',
        }
    }

    async created() {
        const apiService = new ApiService()

        const areasResp = await apiService.getAreas()
        const areas = areasResp.data

        const hobbiesResp = await apiService.getHobbies()
        const hobbies = hobbiesResp.data

        const projectStep = this.steps.find(step => {
            return step.name === 'project'
        })

        const hobbiesStep = this.steps.find(step => {
            return step.name === 'hobbies'
        })

        if (projectStep && hobbiesStep.right.type === 'step') {
            const right = projectStep.right as StepRight
            right.fields[0].options = areas.map(area => {
                return {
                    label: area.name,
                    value: area,
                }
            })
        }

        if (hobbiesStep && hobbiesStep.right.type === 'step') {
            const right = hobbiesStep.right as StepRight
            right.fields[0].options = hobbies.map(hobby => {
                return {
                    label: hobby.name,
                    value: hobby,
                }
            })
        }
    }

    mounted() {
        setTimeout(() => {
            this.loading = false
        }, 2500)
    }
}
